(async () => {
    const { Core } = await importModule('Core');
    const {
        $formatMoney
    }  = await importModule('Utils');

    customElements.define('product-calculator', class extends Core {
        elements = {
            overageTrigger:  '[data-overage]',
            input:  '[data-product-area-quantity-calc]',
            wrapper: '[product-calculator-wrapper]'
        }

        render() {              
            const custom_calculator_info_text_num = this.$wrapper.querySelector('.product-calculator-actual-size-value');
            const custom_calculator_info_text_boxes = this.$wrapper.querySelector('.product-calculator-cartons-value');
            const custom_calculator_info_text_price = this.$wrapper.querySelector('.product-calculator-subtotal-value');
            const sectionID = this.$wrapper.closest("product-variant-listener").getAttribute("section-id");
            const qty_input_by_area = document.querySelector("#"+sectionID+"product-qty-selector");
              
            this.$input?.addEventListener('input', function() {
            let overageValue = this.closest("[product-calculator-wrapper]").querySelector('[data-overage]').checked == true ? 1.05 : 1;  
            let per_box_val = this.getAttribute('data-product-area-quantity-calc');
            let boxes_qty = Math.ceil((this.value * overageValue) / per_box_val);
            let boxes_qty_for_input = Math.ceil(boxes_qty * per_box_val)
            if (custom_calculator_info_text_num != null) {
              custom_calculator_info_text_num.innerHTML= (boxes_qty * per_box_val).toFixed(2);
              
            }
            
            if (custom_calculator_info_text_boxes != null) {
              custom_calculator_info_text_boxes.innerHTML= boxes_qty;
            }
            
            if (custom_calculator_info_text_price != null) {
              let original_price = custom_calculator_info_text_price.getAttribute('data-original-price');
              let formatted_money = $formatMoney(original_price * boxes_qty_for_input, window.theme.moneyFormat);
              custom_calculator_info_text_price.innerHTML = formatted_money;    
            }
            
            if (qty_input_by_area != null) {
              if(boxes_qty_for_input > 0){
              var max_qty = qty_input_by_area.getAttribute("max")*1;
              if(boxes_qty_for_input > max_qty){
                boxes_qty_for_input = max_qty;
              }
                qty_input_by_area.value = boxes_qty_for_input;
              }else{
                qty_input_by_area.value = 1;
              } 
            }
            
          });

          this.$overageTrigger?.addEventListener('change', function() {
            let overageValue = this.checked == true ? 1.05 : 1; 
            let input = this.closest("[product-calculator-wrapper]").querySelector('[data-product-area-quantity-calc]');  
            let per_box_val = input.getAttribute('data-product-area-quantity-calc');
            let boxes_qty = Math.ceil((input.value * overageValue) / per_box_val);
            let boxes_qty_for_input = Math.ceil(boxes_qty * per_box_val); 
            if (custom_calculator_info_text_num != null) {
              custom_calculator_info_text_num.innerHTML= (boxes_qty * per_box_val).toFixed(2);
            }
            
            if (custom_calculator_info_text_boxes != null) {
              custom_calculator_info_text_boxes.innerHTML= boxes_qty;
            }
            
            if (custom_calculator_info_text_price != null) {
              let original_price = custom_calculator_info_text_price.getAttribute('data-original-price');
              let formatted_money = $formatMoney(original_price * boxes_qty_for_input, window.theme.moneyFormat);
              custom_calculator_info_text_price.innerHTML = formatted_money;    
            }
            
            if (qty_input_by_area != null) {
              if(boxes_qty_for_input > 0){
              var max_qty = qty_input_by_area.getAttribute("max")*1;
              if(boxes_qty_for_input > max_qty){
                boxes_qty_for_input = max_qty;
              }
              qty_input_by_area.value = boxes_qty_for_input;
              }else{
                qty_input_by_area.value = 1;
              } 
            }
            
          });

          
        }
    })
})();